"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Types = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Instagram = _interopRequireDefault(require("../../../../icons-react/crm/messengers/Instagram"));
var _Whatsapp = _interopRequireDefault(require("../../../../icons-react/crm/messengers/Whatsapp"));
var _Telegram = _interopRequireDefault(require("../../../../icons-react/crm/messengers/Telegram"));
var _FacebookMessenger = _interopRequireDefault(require("../../../../icons-react/crm/messengers/FacebookMessenger"));
var _Facebook = _interopRequireDefault(require("../../../../icons-react/crm/messengers/Facebook"));
var _Viber = _interopRequireDefault(require("../../../../icons-react/crm/messengers/Viber"));
var _Mail = _interopRequireDefault(require("../../../../icons-react/crm/messengers/Mail"));
var _Vk = _interopRequireDefault(require("../../../../icons-react/crm/messengers/Vk"));
var _Default = _interopRequireDefault(require("../../../../icons-react/crm/messengers/Default"));
var _excluded = ["type"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Types = exports.Types = {
  INSTAGRAM: 'instagram',
  WHATSAPP: 'whatsapp',
  TELEGRAM: 'telegram',
  FACEBOOK_MESSENGER: 'facebook_messenger',
  FACEBOOK: 'facebook',
  VIBER: 'viber',
  MAIL: 'mail',
  VK: 'vk'
};
var Messenger = /*#__PURE__*/function (_React$PureComponent) {
  function Messenger() {
    (0, _classCallCheck2["default"])(this, Messenger);
    return _callSuper(this, Messenger, arguments);
  }
  (0, _inherits2["default"])(Messenger, _React$PureComponent);
  return (0, _createClass2["default"])(Messenger, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        type = _this$props.type,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledMessenger, (0, _extends2["default"])({
        title: type
      }, props), Messenger.getIconByType(type));
    }
  }], [{
    key: "getIconByType",
    value: function getIconByType(type) {
      var icon;
      switch (type) {
        case Types.INSTAGRAM:
          icon = /*#__PURE__*/_react["default"].createElement(_Instagram["default"], null);
          break;
        case Types.WHATSAPP:
          icon = /*#__PURE__*/_react["default"].createElement(_Whatsapp["default"], null);
          break;
        case Types.TELEGRAM:
          icon = /*#__PURE__*/_react["default"].createElement(_Telegram["default"], null);
          break;
        case Types.FACEBOOK_MESSENGER:
          icon = /*#__PURE__*/_react["default"].createElement(_FacebookMessenger["default"], null);
          break;
        case Types.FACEBOOK:
          icon = /*#__PURE__*/_react["default"].createElement(_Facebook["default"], null);
          break;
        case Types.VIBER:
          icon = /*#__PURE__*/_react["default"].createElement(_Viber["default"], null);
          break;
        case Types.MAIL:
          icon = /*#__PURE__*/_react["default"].createElement(_Mail["default"], null);
          break;
        case Types.VK:
          icon = /*#__PURE__*/_react["default"].createElement(_Vk["default"], null);
          break;
        default:
          icon = /*#__PURE__*/_react["default"].createElement(_Default["default"], null);
          break;
      }
      return icon;
    }
  }]);
}(_react["default"].PureComponent);
Messenger.propTypes = {
  className: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(Object.values(Types)).isRequired
};
Messenger.defaultProps = {
  className: ''
};
Messenger.Types = Types;
var StyledMessenger = _styledComponents["default"].div.withConfig({
  displayName: "Messenger__StyledMessenger",
  componentId: "sc-13foj39-0"
})(["width:100%;overflow:hidden;min-width:16px;height:auto;max-width:30px;> svg{height:100%;width:100%;}"]);
var _default = exports["default"] = Messenger;